import request from '../httpClient';

export const sendEmailCode = (email: string) =>
  request.post('/users/send_email_code', {email});

export const verifyEmailCode = (email: string, code: string) =>
  request.post('/users/verify_email_code', {email, code});

export const signup = (
  email: string,
  password: string,
  firstName: string,
  lastName: string,
  roleId: number
) =>
  request.post('/users/signup', {
    email,
    password,
    firstName,
    lastName,
    roleId
  });

export const login = (email: string, password: string) =>
  request.post('/users/login', {email, password});

export const fetchUserInfo = () => request.get('/users/me');

export const changePassword = (currentPassword: string, newPassword: string) =>
  request.put('/users/change_password', {
    oldPassword: currentPassword,
    password: newPassword
  });

export const forgotPassword = (email: string) =>
  request.post('/users/forgot_password', {email});

export const resetPassword = (token: string, password: string) =>
  request.post('/users/reset_password', {token, password});

export const getRoles = () => request.get('/roles');



// WEBPACK FOOTER //
// ./src/services/api/authApi.ts